
<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Edit Purchase</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div
                class="col-sm-12 alert alert-success"
                v-if="haserror.message != ''"
                style="text-align: center;"
              >
                {{ haserror.message }}
              </div>
            </div>
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Supplier Name</label>
                  <span style="display: flex;">
                    <!-- <model-list-select :list="suppliername" option-value="supplier_id" :custom-text="nameAndnumber" v-model="selectedcustomer" @input="onSelectSup($event)" placeholder="Search Supplier Name" @searchchange="searchsupplier"></model-list-select>&nbsp;&nbsp; -->
                    <!-- <a href="#/Purchase/supplier/add"><button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier"><i class="fa fa-user"></i></button></a>
                    <button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier" @click="addSupplier()"><i class="fa fa-user"></i></button> -->
                    <input
                      type="text"
                      class="form-control"
                      id="sup_name"
                      name="txtSupName"
                      v-model="selectsupname"
                      autocomplete="off"
                      :disabled="true"
                    />
                  </span>
                  <small class="form-text text-muted"
                    ><strong style="color: red;">{{
                      haserror.cust
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group>
                  <label for="name">Shop Name</label>
                  <span style="display: flex;">
                    <input
                      type="text"
                      class="form-control"
                      id="shop_name"
                      name="txtShopName"
                      v-model="selectshopname"
                      autocomplete="off"
                      :disabled="true"
                    />

                    <!-- <model-list-select @input="onSelectShp($event)" :list="shopname" :disabled="1 == 1" option-value="est_shop_id" option-text="est_shop_name" v-model="selectshop" placeholder="Select Shop" @searchchange="searchshops"></model-list-select> -->

                    &nbsp;&nbsp;
                    <!-- <a href="#/companyinfo/Shop"><button type="button" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button></a> 
                    <button type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>-->
                  </span>
                  <!-- <a><small class="form-text text-muted" @click="smallmodal1 = true"><strong style="color: blue;">Click here to edit shop</strong></small></a> -->
                  <small class="form-text text-muted"
                    ><strong style="color: red;">{{
                      haserror.shop
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group>
                  <label for="name">Scan Barcode</label>
                  <input
                    type="text"
                    class="form-control"
                    name="barcode"
                    v-model="barcode"
                    @blur="searchBarcode"
                    autocomplete="off"
                    @keyup="checkShop"
                    placeholder="Enter Product Barcode Number"
                  />&nbsp;&nbsp;
                  <small class="form-text text-muted"
                    ><strong style="color: red;">{{
                      haserror.barcode
                    }}</strong></small
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">ITEM DETAILS</span>
          </div>
          <div class="card-body" style="padding: 0px !important;">
            <div class="">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr style="font-size: 12px; text-align: center;">
                    <th width="14%" style="padding-bottom:20px;">Product Name</th>
                    <th width="10%" v-if="productType === 'silver'" style="padding-bottom:20px;">Description</th>
                    <th width="6%" v-if="productType === 'silver'" style="padding-bottom:20px;">Purity</th>
                    <th width="6%" v-if="productType !== 'silver'">Carat Value</th>
                    <th v-if="productType !== 'silver'" width="6%" style="padding-bottom:20px;">Weight</th>
                    <th width="8%" v-if="productType !== 'silver'">Stone Weight</th>
                    <th width="6%" v-if="productType !== 'silver'" style="padding-bottom:20px;">Stone Price</th>
                    <th width="6%" v-if="productType !== 'silver'" style="padding-bottom:20px;">Net Weight</th>
                    <th v-if="productType == 'silver'" width="6%" style="padding-bottom:20px;">Gross Weight</th>
                    <th width="6%" style="padding-bottom:20px;">Qty</th>
                    <!-- DYNAMIC HEADER FOR SILVER -->
                    <th v-if="productType === 'silver'" width="6%" style="padding-bottom:20px;">
                      <span v-if="silverPricingType === 'bulk'">Bulk Amount</span>
                      <span v-else-if="silverPricingType === 'weight'">Price/Gram</span>
                      <span v-else>Amount</span>
                    </th>
                    <th width="6%" v-if="productType !== 'silver'" style="padding-bottom:20px;">Wastage</th>
                    <th width="8%" v-if="productType !== 'silver'" style="padding-bottom:20px;">Price/Unit</th>
                    <th width="2%"  style="padding-bottom:20px;">Making Charges</th>
                    <th width="6%" v-if="is_cs_gst" style="padding-bottom:20px;">SGST %</th>
                    <th width="6%" v-if="is_cs_gst" style="padding-bottom:20px;">CGST %</th>
                    <th width="6%" v-if="is_i_gst" style="padding-bottom:20px;">IGST %</th>
                    <th width="10%" style="padding-bottom:20px;">Total</th>
                    <th width="7%" style="padding-bottom:20px;">Other</th>
                  </tr>
                </thead>
                <tbody id="product_table_body">
                  <tr v-for="(row, index) in rows">
                    <td>
                      <model-list-select
                        :list="row.productnamex"
                        option-value="product_id"
                        option-text="product_name"
                        v-model="row.selectproductrow"
                        placeholder="Search Product Name"
                        @input="openvariant($event, index)"
                        @searchchange="searchprd3($event, index, row)"
                        style="
                          white-space: nowrap;
                          -webkit-text-fill-color: rgb(83, 108, 121) !important;
                          height: 30px !important;
                          border: 1px solid rgb(194, 207, 214);
                          min-height: 30px;
                          border-radius: 1px;
                          padding-top: 6px;
                        "
                        class="product-drop"
                        id="productlist"
                      >
                      </model-list-select>
                      <small
                        style="font-size: 10px; color: darkblue; cursor: pointer;"
                        v-if="row.productExist != ''"
                      >
                        {{ row.productExist }}
                      </small>
                      <small
                        style="font-size: 10px; color: red; cursor: pointer;"
                        @click="openvariant(row, index)"
                        v-if="row.showvariant == true"
                      >
                        Variant <i class="fa fa-info-circle"></i>
                        <small
                          style="font-size: 10px; color: darkblue; cursor: pointer;"
                        >
                          {{ row.variantrow }}
                        </small>
                      </small>
                      <small
                        style="font-size: 10px; color: red; cursor: pointer;"
                        @click="openvariant(row, index)"
                        v-if="row.novariant == true"
                      >
                        Variant
                        <small
                          style="font-size: 10px; color: darkblue; cursor: pointer;"
                        >
                          {{ row.variantrow }}
                        </small>
                      </small>
                    </td>
                    <td v-if="productType === 'silver'" class="position-relative">
                      <textarea
                        class="form-control-sm expandable-input"
                        autocomplete="off"
                        v-model="row.product_desc"
                        style="width: 100%; height: calc(1.5em + 0.5rem + 2px); resize: none; overflow: hidden;"
                        v-on:change="price(index, charge)"
                        v-on:focus="expandInput"
                        v-on:blur="shrinkInput"
                      ></textarea>
                      <small style="font-size: 10px; color: red;" v-if="row.err_product_desc != ''">
                        {{ row.err_product_desc }}
                      </small>
                    </td>
                    <td v-if="productType === 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.purity"
                        style="width: 100%;"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_purity != ''">
                        {{ row.err_purity }}
                      </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control"
                        id="caratvalue"
                        name="carat_value"
                        v-model="row.selectcarat"
                        autocomplete="off"
                        :disabled="true"
                      >
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.weight"
                        style="width: 100%;"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_weight != ''">
                        {{ row.err_weight }}
                      </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.stone_weight"
                        style="width: 100%;"
                        disabled=""
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_weight != ''">
                        {{ row.err_weight }}
                      </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.stone_price"
                        style="width: 100%;"
                        disabled=""
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_weight != ''">
                        {{ row.err_weight }}
                      </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.netweight"
                        style="width: 100%;"
                        disabled=""
                        v-on:change="price(index, charge)"
                      >
                    </td>
                    <td v-if="productType === 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.weight"
                        style="width: 100%;"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_weight != ''">
                        {{ row.err_weight }}
                      </small>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.qty"
                        style="width: 100%;"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_qty != ''">
                        {{ row.err_qty }}
                      </small>
                    </td>
                    <!-- DYNAMIC INPUT FOR SILVER -->
                    <td v-if="productType === 'silver'">
                        <!-- Input for Bulk Amount -->
                        <input
                            v-if="silverPricingType === 'bulk' || !silverPricingType"
                            class="form-control-sm"
                            autocomplete="off"
                            v-model="row.sub_total"
                            step="0.000001"
                            min="0"
                            style="width: 100%;"
                            v-on:input="price(index)"
                        >
                        <!-- Input for Price/Gram -->
                        <input
                            v-if="silverPricingType === 'weight'"
                            class="form-control-sm"
                            autocomplete="off"
                            v-model="row.price"
                            step="0.000001"
                            min="0"
                            style="width: 100%;"
                            v-on:input="price(index)"
                        >
                        <small style="font-size: 10px; color: red;" v-if="row.err_sub_total != ''">
                            {{ row.err_sub_total }}
                        </small>
                        <small style="font-size: 10px; color: red;" v-if="row.err_qty != ''">
                            {{ row.err_qty }}
                        </small>
                        <small style="font-size: 10px; color: red;" v-if="row.err_price != ''">
                            {{ row.err_price }}
                        </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        class="form-control-sm"
                        autocomplete="off"
                        v-model="row.wastage"
                        style="width: 100%;"
                        v-on:change="price(index, charge)"
                        :disabled="true"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_wastage != ''">
                        {{ row.err_wastage }}
                      </small>
                    </td>
                    <td v-if="productType !== 'silver'">
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        v-model="row.price"
                        class="form-control-sm"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_price != ''">
                        {{ row.err_price }}
                      </small>
                    </td>
                    <td>
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        v-model="row.making_charges"
                        class="form-control-sm"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_making_charges != ''">
                        {{ row.err_making_charges }}
                      </small>
                    </td>
                    <td v-if="is_cs_gst">
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        class="form-control-sm"
                        v-model="row.sgst"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_sgst != ''">
                        {{ row.err_sgst }}
                      </small>
                    </td>
                    <td v-if="is_cs_gst">
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        class="form-control-sm"
                        v-model="row.cgst"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_cgst != ''">
                        {{ row.err_cgst }}
                      </small>
                    </td>
                    <td v-if="is_i_gst">
                      <input
                        type="text"
                        style="width: 100%;"
                        autocomplete="off"
                        class="form-control-sm"
                        v-model="row.igst"
                        v-on:change="price(index, charge)"
                      >
                      <small style="font-size: 10px; color: red;" v-if="row.err_igst != ''">
                        {{ row.err_igst }}
                      </small>
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled="disabled"
                        autocomplete="off"
                        v-model="row.amttotal"
                        style="width: 100%;"
                        class="form-control-sm"
                      >
                    </td>
                    <td>
                      <center>
                        <i
                          class="fa fa-bell bell"
                          style="color: red;"
                          v-b-tooltip.hover
                          title="Sale Adjustment"
                          @click="onSelectAdjustment(index, row)"
                          v-if="row.is_adjustment"
                        ></i>
                        <i
                          class="fa fa-reorder"
                          style="color: #20a8d8;"
                          v-b-tooltip.hover
                          title="Add More option"
                          variant="secondary"
                          @click="openmodal(index)"
                        ></i>
                        <i
                          class="fa fa-trash-o"
                          style="color: #f44336;"
                          v-b-tooltip.hover
                          title="Delete"
                          v-on:click="removeElement(index)"
                        ></i>
                      </center>
                    </td>
                  </tr>
              
                  <!-- Rest of the table (summary rows, totals, payment section) remains unchanged -->
                  <tr>
                    <td>
                      <div style="font-size: 13px; color: green;">
                        Add New Row
                        <span
                          style="cursor: pointer;"
                          @click="addRow1"
                          class="badge badge-pill badge-info"
                          v-b-tooltip.hover
                          title="Add New Row"
                        >Add</span>
                      </div>
                    </td>
                    <td style="text-align: right;" :colspan="productType === 'silver' ? 14 : 15">
                      <span style="margin-right:32px;">Additional Discount :</span>
                      <input
                        type=""
                        class="form-control-sm"
                        autocomplete="off"
                        v-on:change="discountadd"
                        v-model="detail.addition"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td style="text-align: right;" :colspan="productType === 'silver' ? 14 : 15">
                      <span style="margin-right:8px;">Total Amount Before Tax:</span>
                      <input
                        type=""
                        class="form-control-sm"
                        :value="totalamt"
                        disabled=""
                      />
                    </td>
                  </tr>
                  <tr v-if="is_cs_gst">
                    <td></td>
                    <td style="text-align: right;" :colspan="productType === 'silver' ? 14 : 15">
                      <span style="margin-right:125px;">SGST:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        disabled=""
                        :value="totalsgst"
                      />
                    </td>
                  </tr>
                  <tr v-if="is_cs_gst">
                    <td></td>
                    <td style="text-align: right;" :colspan="productType === 'silver' ? 14 : 15">
                      <span style="margin-right:125px;">CGST:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        disabled=""
                        :value="totalcgst"
                      />
                    </td>
                  </tr>
                  <tr v-if="is_i_gst">
                    <td></td>
                    <td style="text-align: right;" :colspan="productType === 'silver' ? 14 : 15">
                      <span style="margin-right:130px;">IGST:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        disabled=""
                        :value="totaligst"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: left;">Payment:</td>
                    <td style="text-align: left;">
                      <b-form-select
                        v-model="selected_pytype"
                        :options="lst_paymenttype"
                        v-on:change="paychange"
                      ></b-form-select>
                    </td>
                    <td :colspan="productType === 'silver' ? 13 : 14" style="text-align: right;">
                      <span style="margin-right:53px;">Total Tax Amount:</span>
                      <input
                        type="text"
                        :value="totaltax"
                        disabled=""
                        class="form-control-sm"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="text-align: left;">
                      <b-form-group label="">
                        Payment Mode:
                        <b-form-radio
                          v-model="selected_pymode"
                          name="payment_mode"
                          value="cash"
                          v-on:change="modechange"
                        >Cash</b-form-radio>
                        <b-form-radio
                          v-model="selected_pymode"
                          name="payment_mode"
                          value="cheque"
                          v-on:change="modechange"
                        >Cheque</b-form-radio>
                      </b-form-group>
                    </td>
                    <td :colspan="productType === 'silver' ? 12 : 13" style="text-align: right;">
                      <span style="margin-right:34px;">Total Amount To Pay:</span>
                      <input
                        type="text"
                        :value="totalamtpay"
                        disabled=""
                        class="form-control-sm"
                      />
                    </td>
                  </tr>
                  <tr v-if="fullpay === true">
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:80px;">Amount Paid:</span>
                      <input
                        type="text"
                        disabled
                        class="form-control-sm"
                        :value="total_amt_to_pay"
                      /><br />
                    </td>
                  </tr>
                  <tr v-if="parpay === true">
                    <td></td>
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:80px;">Amount Paid:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        v-model="totalparamtreceived"
                        v-on:change="calbalance()"
                      /><br />
                      <small
                        style="font-size: 10px; color: red;"
                        v-if="amt_rec != ''"
                      >{{ amt_rec }}</small>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:15px;">Previously Paid Amount:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        v-model="totalamtpreviouspaid"
                        disabled=""
                      /><br />
                    </td>
                  </tr>
                  <tr v-if="parpay === true">
                    <td></td>
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:108px;">Balance:</span>
                      <input
                        type="text"
                        class="form-control-sm"
                        disabled=""
                        v-model="bal"
                      />
                    </td>
                  </tr>
                  <tr v-if="chqpay === true">
                    <td></td>
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:88px;">Cheque No.:</span>
                      <input
                        type="text"
                        name="cheque_no"
                        autocomplete="off"
                        v-model="cheque_no"
                        class="form-control-sm"
                        placeholder="Enter Cheque No"
                      /><br />
                      <small
                        style="font-size: 10px; color: red;"
                        v-if="chequeno_validate != ''"
                      >{{ chequeno_validate }}</small>
                    </td>
                  </tr>
                  <tr v-if="chqpay === true">
                    <td></td>
                    <td :colspan="productType === 'silver' ? 14 : 15" style="text-align: right;">
                      <span style="margin-right:35px;">Cheque Date.:</span>
                      <date-picker
                        v-model="cheque_date"
                        editable
                        lang="en"
                        class="form-control-sm"
                      ></date-picker><br />
                      <small
                        style="font-size: 10px; color: red;"
                        v-if="chequedate_validate != ''"
                      >{{ chequedate_validate }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-modal
                title="Add More Option"
                no-close-on-esc
                no-close-on-backdrop
                v-model="largeModal"
                class="modal-info"
                hide-footer
                @ok="largeModal = false"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Batch</label>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="off"
                        name="cmp_phone"
                        v-model="batchmd"
                        placeholder="Enter Batch"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Serial Number </label>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="off"
                        v-model="serialmd"
                        placeholder="Enter Serial Number"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Discount Percentage</label>
                      <input
                        type="text"
                        class="form-control"
                        name="cmp_phone"
                        v-model="percentagemd"
                        autocomplete="off"
                        placeholder="Enter Discount Percentage"
                      />
                      <small class="form-text text-muted"
                        ><strong style="color: red;">{{
                          haserror.dis
                        }}</strong></small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Discount Amount </label>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="off"
                        v-model="amtmd"
                        placeholder="Enter Discount Amount"
                      />
                      <small class="form-text text-muted"
                        ><strong style="color: red;">{{
                          haserror.amt
                        }}</strong></small
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Sales Price</label>
                      <input
                        type="text"
                        class="form-control"
                        name="sale_price"
                        v-model="salepricemd"
                        autocomplete="off"
                        placeholder="Enter Sales Price"
                      />
                      <small class="form-text text-muted"
                        ><strong style="color: red;">{{
                          haserror.saleprice
                        }}</strong></small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <br />
                      <label for="name">Tax Inclusive</label>
                      <input
                        type="checkbox"
                        name="cmp_inclusive"
                        autocomplete="off"
                        v-model="inclusive"
                      />
                      <small class="form-text text-muted"
                        ><strong style="color: red;">{{
                          haserror.inclusive
                        }}</strong></small
                      >
                    </div>
                  </div>
                </div>
                <div class="card-footer modal_footer">
                  <button
                    type="submit"
                    class="btn btn-sm btn-primary"
                    @click="savemodal(indexval)"
                  >
                    <i class="fa fa-dot-circle-o"></i> Save
                  </button>
                </div>
              </b-modal>

              <!-- change shop -->
              <b-modal
                title="Select Shop"
                no-close-on-esc
                no-close-on-backdrop
                size="lg"
                v-model="smallmodal1"
                hide-footer
                @ok="smallmodal1 = false"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <model-list-select
                        :list="shopname"
                        option-value="est_shop_id"
                        option-text="est_shop_name"
                        v-model="selectshop"
                        placeholder="Search Shop"
                      ></model-list-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-warning pull-right"
                        @click="updateshop()"
                      >
                        Update Shop
                      </button>
                    </div>
                  </div>
                </div>
              </b-modal>
              <!-- end  -->

              <!-- changes in popup modal -->
              <b-modal
                title="Select Variant"
                no-close-on-esc
                no-close-on-backdrop
                size="sm"
                v-model="smallmodal"
                hide-footer
                @ok="smallmodal = false"
                @hide=""
              >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <model-list-select
                        :list="variantvalue"
                        option-value="variant_value"
                        option-text="variant_value"
                        v-model="variantdata"
                        placeholder="Search Variant Value"
                        @input="onSelectvariant($event)"
                      ></model-list-select>
                    </div>
                  </div>
                </div>
              </b-modal>
              <!-- end  -->
              <!-- sale Adjustment -->
            </div>
          </div>
          <div class="card-footer">
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              @click="finalsubmit"
            >
              <i class="fa fa-dot-circle-o"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      class="modal-info"
      size="lg"
      title="Edit Purchase"
      no-close-on-esc
      no-close-on-backdrop
      v-model="Adjustment"
      hide-footer
      @ok="Adjustment"
    >
      <div class="card-body">
        <div class="row">
          <div
            class="col-sm-12 alert alert-danger"
            v-if="haserror.message1 != ''"
            style="text-align: center;"
          >
            {{ haserror.message1 }}
          </div>
        </div>
      </div>
      <vue-good-table
        @on-select-all="selectAll"
        @on-row-click="toggleSelectRow"
        :columns="columnsadj"
        :rows="rowsadj"
        :select-options="{ enabled: true }"
        :search-options="{ enabled: true }"
        styleClass="vgt-table striped bordered table-sm condensed"
      ></vue-good-table>
      <div class="card-footer modal_footer">
        <button
          :disabled="disabled == 1 ? true : false"
          type="submit"
          class="btn btn-sm btn-primary"
          @click="save_adjustment()"
        >
          <i class="fa fa-dot-circle-o"></i> Save
        </button>
      </div>
    </b-modal>
    <!-- end sale Adjustment-->
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    "date-picker": DatePicker,
    Spinner,
  },

  data() {
    return {
      columnsadj: [
        {
          label: "Sales ID",
          field: "sale_id",
          width: "10% !important",
        },
        {
          label: "Product Name",
          field: "productname",
          width: "30% !important",
        },
        {
          label: "Variant",
          field: "variant",
          width: "15% !important",
        },
        {
          label: "Qty",
          field: "qty",
          width: "5% !important",
        },
        {
          label: "Amount Per Unit",
          field: "amount",
          width: "20% !important",
        },
        {
          label: "Date",
          field: "createdAt",
          type: "date",
          dateInputFormat: "YYYY-MM-DD",
          dateOutputFormat: "MMM Do YY",
          width: "20% !important",
        },
      ],
      disabled: 0,
      // initload:false,
      selectsupname: null,
      categoryopt: [],
      
      all_unit: null,
      amt_rec: "",
      chequeno_validate: "",
      chequedate_validate: "",
      rowsadj: [],
      purchase_id: null,
      old_shop_id: null,
      productType: '',
      silverPricingType: 'weight', // <-- NEW: To store silver pricing type
      shop_id: null,
      supp_id: null,
      remove_rows: [],
      current_index: null,
      is_cs_gst: true,
      is_i_gst: true,
      Adjustment: false,
      loading: false,
      caratval:[],
      selectcarat:null,
      making_charges:'',
      wastage:'',
      weight:'',
      netweight:'',
      stone_weight:'',
      stone_price:'',
      variantindex: null,
      smallmodal1: false,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      totalamtreceived: "",
      totalparamtreceived: "",
      totalamtpreviouspaid: 0.0,
      total_amt_to_pay: 0.0,
      cheque_no: "",
      cheque_date: "",
      variantvalue: [],
      sup_select: "",
      shp_select: "",
      selectedcustomer: null,
      company_gst: "",
      supplier_gst: "",
      variantdata: null,
      shopdata: null,
      batchmd: "",
      serialmd: "",
      percentagemd: "",
      amtmd: "",
      salepricemd: 0,
      inclusive: false,
      indexval: null,
      largeModal: false,
      suppliername: [],
      selected_pytype: "full",
      lst_paymenttype: [
        { value: "full", text: "Full" },
        { value: "partial", text: "Partial" },
        { value: "no", text: "No" },
      ],
      selected_pymode: "cash",
      barcodelist: [],
      barcode: "",
      shopname: [],
      selectshop: null,
      selectshopname: null,
      prod_lst: [],
      // lst_prod_var:[],
      rows: [],
      haserror: {
        amt: "",
        dis: "",
        cust: "",
        message: "",
        message1: "",
        inclusive: "",
        saleprice: "",
        shop: "",
      },
      detail: {
        totprddis: "",
        transporadd:"",
        addition: "",
        tot: "",
        cgst: "",
        sgst: "",
        igst: "",
        taxamt: "",
        totalamtpay: "",
        totalamtpendingpay: "",
      },
    };
  },

  computed: {
    totaldis() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        if (Number(row.amtmd1) == 0) {
          return (
            total +
            (Number(row.qty) * Number(row.price) * Number(row.percentagemd1)) /
              100
          );
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
      // }
      // else{
      //   return this.detail.totprddis;
      // }
    },
    totalamt() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
      //    }
      // else{
      //   return this.detail.tot;
      // }
    },
    totalcgst() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        return total + (Number(row.cgst) * Number(row.amt)) / 100;
      }, 0);
      all = all.toFixed(4);

      this.detail.cgst = all;
      return all;
      //   }
      // else{
      //   return this.detail.cgst;
      // }
    },
    totalsgst() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        return total + (Number(row.sgst) * Number(row.amt)) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
      //    }
      // else{
      //   return this.detail.sgst;
      // }
    },
    totaligst() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        return total + (Number(row.igst) * Number(row.amt)) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
      //   }
      // else{
      //   return this.detail.igst;
      // }
    },
    totaltax() {
      // if(this.initload == false){
      var all = this.rows.reduce((total, row) => {
        return total + ((Number(row.cgst)*Number(row.amt))/100)+ ((Number(row.sgst)*Number(row.amt))/100)+ ((Number(row.igst)*Number(row.amt))/100);
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
      //   }
      // else{
      //   return this.detail.taxamt;
      // }
    },
    totalamtpay() {


      var data1;
      var data2;
      if(this.detail.addition == '' &&  this.detail.transporadd ==''){
           var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal));
          }, 0);
           all = all.toFixed(4);
          if(this.detail.addition==''){
          this.detail.totalamtpay=all;
          return all

        }
      }


         //begin
        if(this.detail.transporadd != '' || this.detail.addition != ''){
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal));
        }, 0);
        all = all;

        if(this.detail.addition != '' && this.detail.transporadd == ''){
          var minutototal = (all - this.detail.addition)
          this.detail.totalamtpay=minutototal;
          this.totalamtreceived=minutototal;
          this.data1 = minutototal;
          return minutototal;
        }
        else if(this.detail.addition == '' && this.detail.transporadd != ''){
          var total = (parseFloat(all) + parseFloat(this.detail.transporadd))
          this.detail.totalamtpay=total;
          this.totalamtreceived=total;
          this.data2 = total;
          return total;
        }
         else {
           if(data1 != undefined || this.data2 != undefined){
           if(this.data1 != '' && this.data1 != undefined)
           {
              var additionalempty = this.data1 + parseFloat(this.detail.transporadd)
              this.detail.totalamtpay=additionalempty;
              this.totalamtreceived=additionalempty; 
              return  additionalempty;
           }
           if(this.data2 != '' && this.data2 !=undefined){
              var additionalempty = this.data2 - this.detail.addition
              this.detail.totalamtpay=additionalempty;
              this.totalamtreceived=additionalempty; 
              return  additionalempty;
           }  
            return  additionalempty;
         }    
           if(this.data1 == undefined || this.data2 == undefined){
             if(this.detail.addition != ''){
               var part1 = all - this.detail.addition
               this.detail.totalamtpay=part1;
               this.totalamtreceived=part1; 
             } 
             if(this.detail.transporadd != ''){
               var part1 = parseFloat(this.detail.totalamtpay) + parseFloat(this.detail.transporadd)
               this.detail.totalamtpay=part1;
               this.totalamtreceived=part1; 
             }
           
            return  part1;
           }
         }
        }     
 
    },
  },

  created() {
    for (var i = 0; i < 2; i++) {
      var prodlst = [];
      prodlst = this.prod_lst;
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        caratval:[],
        selectcarat:null,
        making_charges:'',
        weight:'',
        netweight:'',
        wastage:'',
        stone_weight:'',
        stone_price:'',
        onlinesaleprice:"",
        qty: "",
        amt: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        batchmd1: "",
        serialmd1: "",
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        salepricemd1: 0,
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: "",
        err_price: "",
        err_onlinesaleprice:"",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        showvariant: false,
        novariant: false,
        productExist: "",
        item_seqno: "",
      });
    }
    this.shopuser();
    Promise.all([
      this.searchsupplier(),
      this.searchshops(),
      this.listproduct(),
      this.getUnit(),
       this.daily_goldprice(),
    ]).then((ret_val) => {
      this.loadPurchaseData();
    });
  },

  methods: {
    expandInput(event) {
  // Store original position
  const rect = event.target.getBoundingClientRect();
  const parentRect = event.target.offsetParent.getBoundingClientRect();
  
  // Calculate position relative to parent
  const top = rect.top - parentRect.top;
  const left = rect.left - parentRect.left;
  
  // Apply floating effect
  event.target.style.position = "absolute";
  event.target.style.top = `${top}px`;
  event.target.style.left = `${left}px`;
  event.target.style.width = "200px"; // Set desired expanded width
  event.target.style.height = "100px"; // Set desired expanded height
  event.target.style.zIndex = "100";
  event.target.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
  event.target.style.overflow = "auto"; // Enable scrolling
  event.target.style.whiteSpace = "normal"; // Allow text wrapping
  event.target.style.padding = "8px"; // Add some padding for better text readability
},

shrinkInput(event) {
  // Reset to original state
  event.target.style.position = "";
  event.target.style.top = "";
  event.target.style.left = "";
  event.target.style.width = "100%";
  event.target.style.height = "calc(1.5em + 0.5rem + 2px)"; // Standard Bootstrap form-control-sm height
  event.target.style.zIndex = "";
  event.target.style.boxShadow = "";
  event.target.style.overflow = "hidden"; // Hide scrollbar when collapsed
  event.target.style.whiteSpace = "nowrap"; // Prevent text wrapping when collapsed
  event.target.style.padding = ""; // Reset padding
},
categorylist(val) {
    if (val === "comp") {
      if (!this.clf_time) {
        this.clf_time = true;
      } else {
        return;
      }
    }

    this.$http
      .get("/api/categories")
      .then((response) => {
        this.categoryopt = response.data;

        // After categoryopt is populated, filter it 
        const type = (this.$route.params.type || '').toLowerCase();
        console.log('Purchase type:', type);
        this.productType = type;  // Store the category type
        console.log('selected category type:', this.productType);
        if (type === 'gold' || type === 'silver') {
          this.matchingCategories = this.categoryopt
          .filter(cat => cat.category_type && cat.category_type.toLowerCase() === type)
          .map(cat => cat.category_id);

          console.log('Matching category IDs:', this.matchingCategories);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
    async getUnit() {
      var _this = this;
      this.$http.get("/api/Unittypes/getUnit").then(function (response) {
        // console.log(response)
        _this.all_unit = response.data.data;
        if (_this.all_unit !== null) {
          return Promise.resolve(true);
        }
      });
    },
    restrictInput(event) {
      const input = event.target;
      const value = input.value;
      const regex = /^\d{1,12}(\.\d{0,6})?$/;
      if (value && !regex.test(value)) {
        input.value = value.slice(0, -1); // Remove last character
      }
    },
    
  daily_goldprice(index,charge){

      var _this = this
    
       this.$http.get('/api/goldprices/getdetails') .then(function (response){
              console.log(response.data)
           
             
                
                _this.charge = response.data[0].price_24
                console.log(_this.charge)
                _this.price(index,_this.charge)
               
           
       
       }) .catch(function(err){
          console.log(err)
        });
    
    },

    calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== "") {
        if (regexp.test(this.totalamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalamtreceived = "";
          return;
        } else {
          this.chng = (
            parseFloat(this.totalamtreceived) -
            parseFloat(this.detail.totalamtpay)
          ).toFixed(4);
        }
      }
    },

    calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== "") {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalparamtreceived = "";
          return;
        } else {
          var paid =
            parseFloat(this.totalparamtreceived) +
            parseFloat(this.totalamtpreviouspaid);
          this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4);
        }
      }
    },

    paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === "full") {
        this.fullpay = true;
        this.total_amt_to_pay =
          parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === "partial") {
        this.parpay = true;
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },

    modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== "no") {
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
          this.cheque_no = "";
          this.cheque_date = "";
        }
      } else {
        this.chqpay = false;
        this.cheque_no = "";
        this.cheque_date = "";
      }
    },

    async searchshops() {
      var _this = this;
      var response = await this.$http.get("/api/shopusers/getShop");
      _this.shopname = response.data;
      if (_this.shopname.length > 0) {
        return Promise.resolve(true);
      }
    },

    async searchsupplier() {
      var _this = this;
      var response = await this.$http.get("/api/suppliers");
      _this.suppliername = response.data;
      if (_this.suppliername.length > 0) {
        return Promise.resolve(true);
      }
    },
    loadPurchaseData() {
        this.productType = this.$route.params.productType;
        this.rows.length = 0;
        this.purchase_id = this.$route.params.purchaseId;
        this.shop_id = this.$route.params.shopId;
        this.old_shop_id = this.$route.params.shopId;
        var __this = this;
        __this.$http.get("/api/purchases/loadData?filter[where][purchase_id]=" + __this.purchase_id + "&filter[where][est_shop_id]=" + __this.shop_id).then(function (res) {
            console.log(res.data);
            console.log(res.data.pur_dtl);
            if (res.status == 200) {
                // <-- NEW: Set silver pricing type from API response -->
                if (__this.productType === 'silver') {
                    __this.silverPricingType = 'weight'; // e.g., 'bulk' or 'weight'
                }

                __this.totalparamtreceived = "";
                __this.detail.totalamtpendingpay = res.data.pur_dtl.amt_pending_pay;
                if (parseFloat(res.data.pur_dtl.additional_discount).toFixed(4) == 0.0000) {
                    __this.detail.addition = '';
                } else {
                    __this.detail.addition = parseFloat(res.data.pur_dtl.additional_discount).toFixed(4);
                }
                console.log('aa ' + res.data.pur_dtl.transportandmiscellaneous);
                if (parseFloat(res.data.pur_dtl.transportandmiscellaneous).toFixed(4) == 0.0000 || res.data.pur_dtl.transportandmiscellaneous == undefined) {
                    __this.detail.transporadd = '';
                } else {
                    __this.detail.transporadd = parseFloat(res.data.pur_dtl.transportandmiscellaneous).toFixed(4);
                }

                var select_sup = __this.suppliername.filter(function (each) {
                    return each.supplier_id === res.data.pur_dtl.supplier_id;
                });
                __this.selectedcustomer = select_sup[0];
                __this.selectsupname = __this.nameAndnumber(select_sup[0]);
                var select_shop = __this.shopname.filter(function (each) {
                    return each.est_shop_id === res.data.pur_dtl.est_shop_id;
                });
                __this.selectshop = select_shop[0];
                __this.company_data();
                __this.selectshopname = __this.selectshop.est_shop_name;
                __this.totalamtpreviouspaid = parseFloat(res.data.pay_dtl).toFixed(4);

                if (
                    parseFloat(res.data.pur_dtl.total_amt_pay) ===
                    parseFloat(res.data.pur_dtl.amt_pending_pay)
                ) {
                    __this.selected_pytype = "no";
                    __this.parpay = false;
                    __this.fullpay = false;
                } else if (parseFloat(res.data.pur_dtl.amt_pending_pay) === 0.0) {
                    __this.selected_pytype = "full";
                    __this.parpay = false;
                    __this.fullpay = true;
                    __this.totalamtreceived = parseFloat(res.data.pay_dtl.amount).toFixed(4);
                } else {
                    __this.selected_pytype = "partial";
                    __this.parpay = true;
                    __this.fullpay = false;
                    __this.bal = parseFloat(res.data.pur_dtl.amt_pending_pay).toFixed(2);
                }

                for (var i = 0; i < res.data.item_data.length; i++) {
                    var pur_disc_amt = "";
                    if (parseFloat(res.data.item_data[i].pur_disc_amt) !== 0) {
                        pur_disc_amt = parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(4);
                    }

                    var pur_disc_pct = "";
                    if (parseFloat(res.data.item_data[i].pur_disc_pct) !== 0) {
                        pur_disc_pct = parseFloat(res.data.item_data[i].pur_disc_pct);
                    }

                    var novariant_val = true;
                    var showvariant_val = false;
                    var variant_val = "";
                    if (
                        res.data.item_data[i].variant_id != null &&
                        res.data.item_data[i].variant_id != ""
                    ) {
                        novariant_val = false;
                        showvariant_val = true;
                        variant_val = res.data.item_data[i].variant_id;
                    }

                    var prod_dt = __this.prod_lst.filter(function (each) {
                        return each.product_id === res.data.item_data[i].product_id;
                    });

                    var igst = 0.0;
                    var sgst = 0.0;
                    var cgst = 0.0;
                    if (
                        parseFloat(res.data.item_data[i].sgst_amt) === 0 &&
                        parseFloat(res.data.item_data[i].cgst_amt) === 0 &&
                        parseFloat(res.data.item_data[i].igst_amt) === 0
                    ) {
                        igst = 0.0;
                        sgst = 0.0;
                        cgst = 0.0;
                    } else if (
                        parseFloat(res.data.item_data[i].cgst_amt) !== 0 &&
                        parseFloat(res.data.item_data[i].sgst_amt) !== 0
                    ) {
                        cgst = res.data.item_data[i].cgst_amt;
                        sgst = res.data.item_data[i].sgst_amt;
                    } else {
                        igst = res.data.item_data[i].igst_amt;
                    }

                    var unit_value = "";
                    if (res.data.item_data[i].unit_id in __this.all_unit) {
                        unit_value = __this.all_unit[res.data.item_data[i].unit_id];
                    }
                    var tempcarat_value = res.data.item_data[i].carat_value;

                    // Handle product_desc and purity, default to empty string if not present
                    var product_desc = res.data.item_data[i].product_desc || "";
                    var purity = res.data.item_data[i].purity || "";
                    var sub_total = res.data.item_data[i].sub_total || "";


                    var new_row = {
                        wastage: res.data.item_data[i].wastage,
                        productnamex: prod_dt,
                        selectedproductid: res.data.item_data[i].product_id,
                        selectproductrow: prod_dt[0],
                        unit: res.data.item_data[i].unit_value,
                        qty: res.data.item_data[i].purchase_qty,
                        price: res.data.item_data[i].product_unit_cost,
                        making_charges: res.data.item_data[i].making_charges,
                        selectcarat: tempcarat_value,
                        weight: res.data.item_data[i].weight,
                        stone_weight: res.data.item_data[i].stone_weight,
                        stone_price: res.data.item_data[i].stone_price,
                        amttotal: res.data.item_data[i].amt_to_pay,
                        amtmd1: pur_disc_amt,
                        cgst: cgst,
                        sgst: sgst,
                        igst: igst,
                        amt: res.data.item_data[i].sub_total,
                        unit: unit_value,
                        inclusive1: res.data.item_data[i].tax_inclusive,
                        item_seqno: res.data.item_data[i].item_seq_no,
                        productExist: "",
                        percentagemd1: pur_disc_pct,
                        netweight: res.data.item_data[i].netweight,
                        product_desc: product_desc,
                        purity: purity,
                        sub_total: sub_total
                    };
                    __this.rows.push(new_row);
                    __this.loading = false;
                    console.log(res.data.item_data[i].amt_to_pay);
                }
                __this.onSelectSup(__this.selectedcustomer);
            } else {
                console.log("Didnt got response");
            }
        })
        .catch(function (error) {
            console.error("Error loading purchase data:", error);
        });
    },

    async listproduct() {
      var _this = this;
      var response = await this.$http.get("/api/companyproducts");
      _this.prod_lst = response.data;

      if (_this.prod_lst.length > 0) {
        return Promise.resolve(true);
      }
      // }.catch(function (error) {
      //   console.log("error.response");
      // });
    },

    checkVariant(index) {
      if (this.variantdata == null) {
        this.rows[index].adjustment_list = [];
        this.rows[index].adjusted = [];
        // this.rows[index].productnamex=[]
        this.rows[index].selectedproductid = null;
        this.rows[index].unit = "";
        this.rows[index].selectproductrow = null;
        this.rows[index].price = "";
        this.rows[index].qty = "";
        this.rows[index].amt = "";
        this.rows[index].cgst = 0;
        this.rows[index].sgst = 0;
        this.rows[index].igst = "";
        this.rows[index].batchmd1 = "";
        this.rows[index].serialmd1 = "";
        this.rows[index].is_adjustment = false;
        this.rows[index].amttotal = 0;
        this.rows[index].percentagemd1 = "";
        this.rows[index].amtmd1 = "";
        this.rows[index].variantrow = "n/a";
        this.rows[index].unitvalue = "";
        this.rows[index].novariant = false;
        this.rows[index].showvariant = false;
        this.rows[index].inclusive1 = false;
        this.rows[index].err_qty = "";
        this.rows[index].err_price = "";
        this.rows[index].err_onlinesaleprice="";
        this.rows[index].err_sgst = "";
        this.rows[index].err_cgst = "";
        this.rows[index].err_igst = "";
        this.rows[index].productExist = "";
        this.rows[index].item_seqno = "";
      }
    },
    checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Supplier";
        this.barcode = "";
      } else {
        this.haserror.cust = "";
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = "";
      } else {
        this.haserror.shop = "";
      }
    },

    searchBarcode() {
      var _this = this;

      var option = [];
      var index = 0;
      var addRow = 0;
      var barcode = this.barcode;

      this.checkShop();

      this.barcode = "";
      if (barcode) {
        this.$http
          .get("/api/purchasereturns/joinproduct2?barcode=" + barcode)
          .then(function (response) {
            var valueArr = _this.rows.map((item) => item);
            var rowindex = -1;
            var check = valueArr.some(function (value, indx) {
              if (value.selectproductrow == null) {
                rowindex = indx;

                return true;
              } else {
                return false;
              }
            });
            if (response.data[0] != null) {
              if (_this.rows.length == 0 || rowindex == -1) {
                rowindex = rowindex != -1 ? rowindex : _this.rows.length;
                _this.rows.push({
                  productnamex: [],
                  selectedproductid: "",
                  unit: "",
                  unitvalue: "",
                  selectproductrow: null,
                  price: "",
                  qty: "",
                  amt: "",
                  cgst: 0,
                  sgst: 0,
                  igst: "",
                  amttotal: 0,
                  batchmd1: "",
                  serialmd1: "",
                  percentagemd1: "",
                  amtmd1: "",
                  variantrow: "n/a",
                  inclusive1: false,
                  salepricemd1: 0,
                  is_adjustment: false,
                  adjustment_list: [],
                  adjusted: [],
                  err_qty: "",
                  err_price: "",
                  err_onlinesaleprice:"",
                  err_sgst: "",
                  err_cgst: "",
                  err_igst: "",
                  showvariant: false,
                  novariant: false,
                  productExist: "",
                  item_seqno: "",
                });
              }
              _this.rows[rowindex].productnamex.push(response.data[0]);
              _this.rows[rowindex].selectproductrow = response.data[0];
              // console.log('select product row')
              // console.log(_this.rows[rowindex].selectproductrow)
              _this.openvariant(response.data[0], rowindex);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
      }
    },

    nameAndnumber(item) {
      return `${item.sup_cmp_name} - ${item.sup_cmp_phone}`;
    },

    shopuser() {
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {
          return Promise.resolve(true);
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    onSelectAdjustment(index, row) {
      this.current_index = null;
      this.current_index = index;
      this.haserror.message1 = "";
      this.disabled = 0;
      this.Adjustment = true;
      this.rowsadj = [];

      for (var i = 0; i < row.adjustment_list.length; i++) {
        if (row.adjusted.length > 0) {
          var vgtSelected = false;
          for (var j = 0; j < row.adjusted.length; j++) {
            if (row.adjusted[j] == row.adjustment_list[i].saleadjustment_id) {
              var vgtSelected = true;
            }
          }
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].sale_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: vgtSelected,
          });
        } else {
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].sale_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: false,
          });
        }
      }
      this.checking_adjustment();
    },

    save_adjustment() {
      this.rows[this.current_index].adjusted = [];
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i]["vgtSelected"] == true) {
          this.rows[this.current_index].adjusted.push(
            this.rowsadj[i]["sale_id"]
          );
        }
      }
      this.Adjustment = false;
    },

    selectAll(selected, selectedRows) {
      if (selected.selectedRows.length === 0) {
        var vgtSelected = false;
      } else {
        var vgtSelected = true;
      }

      for (var i = 0; i < this.rowsadj.length; i++) {
        this.rowsadj[i]["vgtSelected"] = vgtSelected;
      }
      this.checking_adjustment();
    },

    toggleSelectRow(params) {
      this.rowsadj[params.row.originalIndex]["vgtSelected"] =
        params.row.vgtSelected;
      this.checking_adjustment();
    },

    checking_adjustment() {
      var row_qty = this.rows[this.current_index]["qty"];
      var adj_qty = 0;
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i].vgtSelected) {
          adj_qty += parseFloat(this.rowsadj[i].qty);
        }
      }
      if (adj_qty > row_qty) {
        this.disabled = 1;
        this.haserror.message1 =
          "Adjustment Quantity Cannot Be Greater Than Purchase Quantity";
      } else {
        this.disabled = 0;
        this.haserror.message1 = "";
      }
    },

    company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },

    onSelectShp(option) {
      this.haserror.shop = "";
      if (option.id != undefined) {
        if (
          this.selectshop == null ||
          this.selectshop.est_shop_id === undefined
        ) {
          this.haserror.shop = "Please Select Shop";
        }
      } else {
        this.haserror.shop = "Please Select Shop";
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.sale_adjustment(this.rows[i].selectproductrow, i);
          }
        }
      }
    },

    onSelectSup(option) {
      //this.is_cs_gst = true;
     // this.is_i_gst = true;

      if (option.sup_cmp_gst != undefined) {
        this.haserror.cust = "";
        this.supplier_gst = option.sup_cmp_gst;
      }

      if (this.company_gst && this.supplier_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var supplier_gst = this.supplier_gst.substring(0, 2);
        if (company_gst === supplier_gst) {
          //this.is_cs_gst = true;
         // this.is_i_gst = false;
        } else {
          //this.is_cs_gst = false;
          //this.is_i_gst = true;
        }
      } else if (this.supplier_gst === null || this.supplier_gst === "") {
        //this.is_cs_gst = false;
        //this.is_i_gst = false;
      } else {
        //this.is_cs_gst = true;
        //this.is_i_gst = true;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.variantindex = i;
            // this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },

    onSelectvariant(option) {
      if (option.variant_value === "No Variant") {
        this.rows[this.variantindex]["variantrow"] = "n/a";
      } else {
        this.rows[this.variantindex]["variantrow"] = option.variant_value;
      }
      this.smallmodal = false;
      // var curr_prod = this.rows[this.variantindex]['selectproductrow']['product_id']
      // var curr_var = this.rows[this.variantindex]['variantrow']

      // if(this.lst_prod_var.length > 0){
      //   if(this.lst_prod_var.indexOf(curr_prod+'_'+curr_var) !== -1){
      //     alert('Item - ' + this.rows[this.variantindex]['selectproductrow']['product_name'] + ' with variant ' + option.variant_value + ' already added above. Kindly select other product')
      //       this.rows[this.variantindex]['selectproductrow']=null;
      //       this.rows[this.variantindex]['variantrow']=null
      //       return
      //   }
      // }
      // this.lst_prod_var[this.variantindex] = curr_prod+'_'+curr_var
      // var index = this.variantindex
      // var _this = this
      // var row = this.rows[this.variantindex]

      var row = this.rows[this.variantindex].selectproductrow;
      this.sale_adjustment(row, this.variantindex);
      this.onSelect(row, this.variantindex);
    },

    updateshop() {
      this.loading = true;
      var _this = this;
      this.$http
        .post(
          "/api/purchases/updateShop?filter[where][purchase_id]=" +
            this.purchase_id +
            "&filter[where][old_shop_id]=" +
            this.old_shop_id +
            "&filter[where][est_shop_id]=" +
            this.selectshop.est_shop_id
        )
        .then(function (response) {
          if (response.status == 200) {
            // console.log(response.data.data)
            if (response.data.data == "Successful") {
              _this.$route.params.shopId = _this.selectshop.est_shop_id;
              setTimeout(function () {
                _this.loadPurchaseData();
                _this.smallmodal1 = false;
                _this.loading = false;
              }, 1000);
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.haserror.message = "Purchase Updated Successfully";
              setTimeout(function () {
                _this.haserror.message = "";
              }, 3000);
            }
          }
        })
        .catch(function (error) {});
    },

    openvariant_on_product(row, index) {
      if ("product_id" in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },

    openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id =
        row.selectproductrow == null
          ? row.variant_id
          : row.selectproductrow.variant_id;

      if (vrnt_id != null) {
        this.rows[this.variantindex].novariant = false;
        this.rows[this.variantindex].showvariant = true;
        this.smallmodal = true;

        this.$http
          .get("/api/variantvalues?filter[where][variant_id]=" + vrnt_id)
          .then(function (response) {
            _this.variantvalue = response.data;
            _this.variantvalue.unshift({
              company_id: "I2OCGLB",
              id: 0,
              regcity_code: "I2O",
              variant_id: "0",
              variant_value: "No Variant",
            });
          })
          .catch(function (error) {});
      } else {
        this.rows[this.variantindex].novariant = true;
        this.rows[this.variantindex].showvariant = false;
        var option = {
          company_id: "I2OCGLB",
          id: 0,
          regcity_code: "I2O",
          variant_id: "0",
          variant_value: "No Variant",
        };
        _this.onSelectvariant(option);
        _this.smallmodal = false;
      }
    },

    sale_adjustment(option, index) {
      var _this = this;
      this.$http
        .get(
          "/api/salesadjustments?filter[where][est_shop_id]=" +
            _this.selectshop.est_shop_id +
            "&filter[where][product_id]=" +
            option.product_id +
            "&filter[where][variant_id]=" +
            _this.rows[index]["variantrow"]
        )
        .then(function (response) {
          if (response.data.length > 0) {
            _this.rows[index]["adjustment_list"] = response.data;
            _this.rows[index]["is_adjustment"] = true;
          } else {
            _this.rows[index]["adjustment_list"] = [];
            _this.rows[index]["is_adjustment"] = false;
            _this.rows[index]["adjusted"] = [];
          }
        })
        .catch(function (error) {});
      this.onSelect(option, index);
    },

    // show_tax(option, index) {
    //   var _this = this;
    //   this.$http
    //     .get("/api/taxrates/findOne?filter[where][tax_id]=" + option.tax_gst_id)
    //     .then(function (response) {
    //       if (_this.company_gst && _this.supplier_gst) {
    //         var company_gst = _this.company_gst.substring(0, 2);
    //         var supplier_gst = _this.supplier_gst.substring(0, 2);
    //         // _this.rows[index]['inclusive1'] = false
    //         if (company_gst === supplier_gst) {
    //           _this.rows[index]["cgst"] = response.data.tax_cgst;
    //           _this.rows[index]["sgst"] = response.data.tax_sgst;
    //           _this.rows[index]["igst"] = 0.0;
    //         } else {
    //           _this.rows[index]["cgst"] = 0.0;
    //           _this.rows[index]["sgst"] = 0.0;
    //           _this.rows[index]["igst"] = response.data.tax_igst;
    //         }
    //        // _this.price(index);
    //       } else if (_this.supplier_gst === null || _this.supplier_gst === "") {
    //          _this.rows[index]['inclusive1'] = true
    //         _this.rows[index]["cgst"] = 0.0;
    //         _this.rows[index]["sgst"] = 0.0;
    //         _this.rows[index]["igst"] = 0.0;
    //         _this.price(index);
    //       } else {
    //         // _this.rows[index]['inclusive1'] = false
    //         if (
    //           _this.rows[index]["cgst"] === 0.0 &&
    //           _this.rows[index]["sgst"] === 0.0 &&
    //           _this.rows[index]["igst"] === 0.0
    //         ) {
    //           _this.rows[index]["cgst"] = 0.0;
    //           _this.rows[index]["sgst"] = 0.0;
    //           _this.rows[index]["igst"] = 0.0;
    //         } else if (
    //           _this.rows[index]["cgst"] === 0.0 &&
    //           _this.rows[index]["sgst"] === 0.0 &&
    //           _this.rows[index]["igst"] !== 0.0
    //         ) {
    //           _this.rows[index]["cgst"] = 0.0;
    //           _this.rows[index]["sgst"] = 0.0;
    //           _this.rows[index]["igst"] = response.data.tax_igst;
    //         } else {
    //           _this.rows[index]["cgst"] = response.data.tax_cgst;
    //           _this.rows[index]["sgst"] = response.data.tax_sgst;
    //           _this.rows[index]["igst"] = 0.0;
    //         }
    //         _this.price(index);
    //       }
    //     });
    // },
    onSelect(option, index) {
      var _this = this;
      _this.rows[index]["inclusive1"] = false;
      _this.current_index = null;
      if (option != null) {
        if (option.alt_product_id != undefined) {
          // _this.show_tax(option, index);
          // _this.rows[index]['qty']=1
          _this.rows[index]["unit"] = option.unit_name;
          _this.rows[index]["unitvalue"] = option.unit_id;
          _this.rows[index]["selectedproductid"] = option.variant_id;
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
        } else {
          _this.rows[index]["selectedproductid"] = "";
          _this.rows[index]["unit"] = "";
          _this.rows[index]["unitvalue"] = "";
          _this.rows[index]["selectproductrow"] = null;
          _this.rows[index]["price"] = "";
          _this.rows[index]["qty"] = "";
          _this.rows[index]["amt"] = "";
          _this.rows[index]["cgst"] = 0;
          _this.rows[index]["sgst"] = 0;
          _this.rows[index]["igst"] = "";
          _this.rows[index]["amttotal"] = 0;
          _this.rows[index]["batchmd1"] = "";
          _this.rows[index]["serialmd1"] = "";
          _this.rows[index]["percentagemd1"] = "";
          _this.rows[index]["amtmd1"] = "";
          _this.rows[index]["variantrow"] = "n/a";
          _this.rows[index]["inclusive1"] = false;
          _this.rows[index]["salepricemd1"] = 0;
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
          _this.rows[index]["item_seqno"] = "";
          _this.rows[index].showvariant = false;
          _this.rows[index].novariant = false;
        }
      } else {
        _this.rows[index]["selectedproductid"] = "";
        _this.rows[index]["unit"] = "";
        _this.rows[index]["unitvalue"] = "";
        _this.rows[index]["selectproductrow"] = null;
        _this.rows[index]["price"] = "";
        _this.rows[index]["qty"] = "";
        _this.rows[index]["amt"] = "";
        _this.rows[index]["cgst"] = 0;
        _this.rows[index]["sgst"] = 0;
        _this.rows[index]["igst"] = "";
        _this.rows[index]["amttotal"] = 0;
        _this.rows[index]["batchmd1"] = "";
        _this.rows[index]["serialmd1"] = "";
        _this.rows[index]["percentagemd1"] = "";
        _this.rows[index]["amtmd1"] = "";
        _this.rows[index]["variantrow"] = "n/a";
        _this.rows[index]["inclusive1"] = false;
        _this.rows[index]["salepricemd1"] = 0;
        _this.rows[index]["adjustment_list"] = [];
        _this.rows[index]["adjusted"] = [];
      }

      // _this.sale_adjustment(option,index)
    },

    openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.batchmd = "";
      this.serialmd = "";
      this.percentagemd = "";
      this.amtmd = "";
      this.salepricemd = "";
      if (this.rows[test]["percentagemd1"] != "") {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != "") {
        this.amtmd = this.rows[test].amtmd1;
      }
      if (this.rows[test]["batchmd1"] != "") {
        this.batchmd = this.rows[test].batchmd1;
      }
      if (this.rows[test]["serialmd1"] != "") {
        this.serialmd = this.rows[test].serialmd1;
      }

      this.inclusive = this.rows[test].inclusive1;
      this.salepricemd = this.rows[test].salepricemd1;
    },

    addRow1() {
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        caratval:[],
        selectcarat:null,
        making_charges:'',
        weight:'',
        pricing_type: silverPricingType,
        netweight:'',
        wastage:'',
        qty: "",
        amt: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        batchmd1: "",
        serialmd1: "",
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        salepricemd1: 0,
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: "",
        err_price: "",
        err_onlinesaleprice:"",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        showvariant: false,
        novariant: false,
        productExist: "",
        item_seqno: "",
      });
      this.selected_pytype = "partial";
      this.selected_pymode = "cash";
      this.parpay = true;
    },

    removeElement: function (index) {
      var _this = this;
      if (this.rows[index].item_seqno != "") {
        this.$http
          .get(
            "/api/estshopinventories?filter[where][est_shop_id]=" +
              this.shop_id +
              "&filter[where][product_id]=" +
              this.rows[index].selectproductrow.product_id +
              "&filter[where][variant_id]=" +
              this.rows[index].variantrow +
              "&filter[fields][quantity]=true"
          )
          .then(function (response) {
            if (
              parseFloat(response.data[1].quantity) >=
              parseFloat(_this.rows[index]["old_qty"])
            ) {
              _this.remove_rows.push(_this.rows[index]);
              _this.rows.splice(index, 1);
              _this.manage_pre_paid();
            } else {
              alert(
                "Item detail - " +
                  _this.rows[index].selectproductrow.product_name +
                  " " +
                  _this.rows[index].variantrow +
                  " cannot be removed from purchase record as its been adjusted in Sale Adjustment"
              );
            }
          });
      } else {
        this.rows.splice(index, 1);
        this.manage_pre_paid();
        // this.loading = false
      }
    },

    manage_pre_paid() {
    
      if (
        parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)
      ) {
        this.paychange("full");
        this.modechange("cash");
        // this.selected_pytype = 'full'
        // this.selected_pymode = 'cash'
        // this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(2)
        this.totalparamtreceived = "";
        //totalamtreceived shuld be disable
        this.totalamtreceived = "";
        this.totamtrecdis = true;
      } else if (
        parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)
      ) {
        this.paychange("full");
        this.modechange("cash");
        // this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(2)
        this.totalparamtreceived = "";
        this.totalamtreceived = "";
        this.totamtrecdis = true;
      } else {
        this.paychange("partial");
        this.modechange("cash");
        this.totalparamtreceived = "";
        // console.log(this.totalamtpay)
        // console.log(this.totalamtpreviouspaid)
        // console.log(parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid))
        this.bal = (
          parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)
        ).toFixed(4);
        this.totamtrecdis = false;
      }
    },

    searchprd3(searchText, index, row) {
      this.haserror.cust = "";
      this.haserror.shop = "";
      var status = 1;
      console.log('search has been called')

      if (
        this.selectedcustomer == null ||
        this.selectedcustomer.supplier_id === undefined
      ) {
        status = 0;
        this.haserror.cust = "Please Select Supplier";
      }
      if (
        this.selectshop == null ||
        this.selectshop.est_shop_id === undefined
      ) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }

      if (status == 1) {
        var _this = this;
        if (searchText) {
            console.log('selected category type:', this.productType);

const baseUrl = `/api/purchasereturns/joinproduct2?data=${searchText}`;
let query = baseUrl;

if (this.productType.toLowerCase() !== 'gold' && this.matchingCategories.length > 0) {
  query += `&category_ids=${this.matchingCategories.join(',')}`;
}
          this.$http
            .get(query)
            .then(function (response) {
              row.productnamex = response.data;
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },

    savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = "";
      this.haserror.dis = "";
      if (this.percentagemd != "" && this.amtmd != "") {
        this.haserror.amt = "Please Select Any One";
      } else if (
        this.percentagemd != "" &&
        num.test(this.percentagemd) == false
      ) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != "" && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]["amt"])) {
        this.haserror.amt =
          "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]["batchmd1"] = this.batchmd;
        this.rows[val]["serialmd1"] = this.serialmd;
        this.rows[val]["percentagemd1"] = this.percentagemd;
        this.rows[val]["amtmd1"] = this.amtmd;
        this.rows[val]["inclusive1"] = this.inclusive;
        this.rows[val]["salepricemd1"] = this.salepricemd;
        this.largeModal = false;
        this.price(val);
      }
    },

     trasportsss(){
        var num=/^\d{1,12}(\.\d{1,6})?$/
        if(num.test(this.detail.transporadd)==false && this.detail.transporadd!=='' ){
          this.detail.transporadd='';
          alert("Please Provide Valid Integer For Additional Discount");
        }
        if(parseFloat(this.detail.totalamtpay)<0){
          this.detail.transporadd='';
          alert("Invalid Entry" )
        }
        if(this.selected_pytype === 'partial'){
             if(this.totalparamtreceived !== ''){
               this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
             }
        }
    },

    discountadd() {
      // var num=/^[0-9]{1,11}$/
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (
        num.test(this.detail.addition) == false &&
        this.detail.addition !== ""
      ) {
        this.detail.addition = "";
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) < 0) {
        this.detail.addition = "";
        alert("Invalid Entry");
      }
    },

   price(index, charge) {
    var prc = charge;
    var num = /^[0-9]{1,11}$/;
    var price = /^\d{1,12}(\.\d{1,6})?$/;
    var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
    var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

    // Initialize tax values with fallbacks
    let sgst = parseFloat(this.rows[index]["sgst"]) || 0;
    let cgst = parseFloat(this.rows[index]["cgst"]) || 0;
    let igst = parseFloat(this.rows[index]["igst"]) || 0;

    // Validate taxes
    if (igstexp.test(this.rows[index]["igst"]) == false && this.rows[index]["igst"] != "") {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
        igst = 0;
    } else if (igst < 0) {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
        igst = 0;
    } else {
        this.rows[index]["err_igst"] = "";
    }

    if (tax.test(this.rows[index]["sgst"]) == false && this.rows[index]["sgst"] != "") {
        this.rows[index]["sgst"] = "";
        this.rows[index]["err_sgst"] = "Invalid";
        sgst = 0;
    } else if (sgst < 0) {
        this.rows[index]["sgst"] = "";
        this.rows[index]["err_sgst"] = "Invalid";
        sgst = 0;
    } else {
        this.rows[index]["err_sgst"] = "";
    }

    if (tax.test(this.rows[index]["cgst"]) == false && this.rows[index]["cgst"] != "") {
        this.rows[index]["cgst"] = "";
        this.rows[index]["err_cgst"] = "Invalid";
        cgst = 0;
    } else if (cgst < 0) {
        this.rows[index]["cgst"] = "";
        this.rows[index]["err_cgst"] = "Invalid";
        cgst = 0;
    } else {
        this.rows[index]["err_cgst"] = "";
    }

    // Tax synchronization logic (applies to all product types)
    let igst_value = 0;
    if (igst > 0) {
        this.rows[index]["sgst"] = 0;
        this.rows[index]["cgst"] = 0;
        this.rows[index]["err_sgst"] = "";
        this.rows[index]["err_cgst"] = "";
        igst_value = igst;
        sgst = cgst = 0;
    } else if (sgst > 0 && cgst !== sgst) {
        this.rows[index]["cgst"] = this.rows[index]["sgst"];
        cgst = sgst;
    } else if (cgst > 0 && sgst !== cgst) {
        this.rows[index]["sgst"] = this.rows[index]["cgst"];
        sgst = cgst;
    }

    var total = 0;

    // Silver pricing
    if (this.productType === 'silver') {
        this.rows[index]["pricing_type"] = this.silverPricingType;
        if (this.rows[index]["qty"] == "" || parseFloat(this.rows[index]["qty"]) <= 0.0 || price.test(this.rows[index]["qty"]) == false) {
            this.rows[index]["err_qty"] = "Invalid Quantity";
        } else {
            this.rows[index]["err_qty"] = "";
        }
        
        if (this.silverPricingType === 'weight') {
            this.rows[index]['err_price'] = '';
            this.rows[index]['err_sub_total'] = '';

            if (this.rows[index]["price"] == "" || parseFloat(this.rows[index]["price"]) <= 0.0 || price.test(this.rows[index]["price"]) == false) {
                this.rows[index]["err_price"] = "Invalid Price/Gram";
                this.rows[index].sub_total = 0;
            } else {
                const pricePerGram = parseFloat(this.rows[index].price) || 0;
                const weight = parseFloat(this.rows[index].weight) || 0;
            var making_charges = parseFloat(this.rows[index].making_charges) || 0;
            console.log('making charges', making_charges)

                const qty = parseFloat(this.rows[index].qty) || 0;
                const subTotal = pricePerGram * weight * qty + (making_charges * weight * qty);
                this.rows[index].sub_total = subTotal.toFixed(4);
                total = subTotal;
            }
        } else { // Bulk pricing
            this.rows[index]['err_price'] = '';
            this.rows[index]['err_sub_total'] = '';

            if (this.rows[index]['sub_total'] == "" || parseFloat(this.rows[index]["sub_total"]) <= 0.0 || price.test(this.rows[index]["sub_total"]) == false) {
                this.rows[index]['err_sub_total'] = 'Invalid Bulk Amount';
                this.rows[index].price = 0;
            } else {
                total = parseFloat(this.rows[index]['sub_total']) || 0;
                const qty = parseFloat(this.rows[index].qty) || 0;
                if (total > 0 && qty > 0) {
                    this.rows[index].price = (total / qty).toFixed(4);
                } else {
                    this.rows[index].price = 0;
                }
            }
        }
    } 

    // Non-silver pricing
    if (this.productType !== 'silver') {
        if (this.rows[index]['price'] != '' && this.rows[index]['qty'] != '' && this.rows[index].selectcarat.carat_value != '' && this.rows[index]['wastage'] != '' && this.rows[index]['weight'] != '' && this.rows[index]['stone_weight'] != '' && this.rows[index]['stone_price'] != '' && this.rows[index]['making_charges'] != '') {
            var price = parseFloat(this.rows[index]['price']) || 0;
            var stone_price = parseFloat(this.rows[index]['stone_price']) || 0;
            var making_charges = parseFloat(this.rows[index]['making_charges']) || 0;
            var qty = parseInt(this.rows[index]['qty']) || 0;
            var wastage = parseFloat(this.rows[index]['wastage']) || 0;
            var weight = parseFloat(this.rows[index]['weight']) || 0;
            var stone_weight = parseFloat(this.rows[index]['stone_weight']) || 0;
            this.rows[index]['netweight'] = parseFloat(weight + wastage - stone_weight).toFixed(3);
            var grossweight = parseFloat(this.rows[index]['netweight']);
            total = ((price * grossweight) + making_charges + stone_price) * qty;
        } else {
            // Simplified default case for incomplete inputs
            var price = parseFloat(this.rows[index]['price']) || 0;
            var stone_price = parseFloat(this.rows[index]['stone_price']) || 0;
            var making_charges = parseFloat(this.rows[index]['making_charges']) || 0;
            var qty = parseInt(this.rows[index]['qty']) || 0;
            var wastage = parseFloat(this.rows[index]['wastage']) || 0;
            var weight = parseFloat(this.rows[index]['weight']) || 0;
            var stone_weight = parseFloat(this.rows[index]['stone_weight']) || 0;
            this.rows[index]['netweight'] = parseFloat(weight + wastage - stone_weight).toFixed(3);
            var grossweight = parseFloat(this.rows[index]['netweight']);
            total = ((price * grossweight) + making_charges + stone_price) * qty;
        }
    }

    // Apply discounts
    if (this.rows[index]["percentagemd1"] != "") {
        total = total - (total * (parseFloat(this.rows[index]["percentagemd1"]) || 0)) / 100;
    }
    if (this.rows[index]["amtmd1"] != "") {
        total = total - (parseFloat(this.rows[index]["amtmd1"]) || 0);
    }

    // Calculate final amount
    if (total !== undefined && !isNaN(total)) {
        if (this.rows[index]["inclusive1"] == false) {
            this.rows[index]["amt"] = total.toFixed(4);
            var amttotal = total + (sgst * total) / 100 + (cgst * total) / 100 + (igst_value * total) / 100;
            this.rows[index]["amttotal"] = isNaN(amttotal) ? "0.0000" : amttotal.toFixed(4);
        } else {
            this.rows[index]["amttotal"] = total.toFixed(4);
            var total_percentage = sgst + cgst + igst_value;
            var bfttotal = total * (100 / (100 + (total_percentage || 0)));
            this.rows[index]["amt"] = isNaN(bfttotal) ? "0.0000" : bfttotal.toFixed(4);
        }
    } else {
        this.rows[index]["amt"] = "0.0000";
        this.rows[index]["amttotal"] = "0.0000";
    }

    this.manage_pre_paid();
},

    finalsubmit() {
      console.log("in final submit ")
      this.haserror.message = "";
      this.haserror.cust = "";
      this.haserror.shop = "";
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {
          if (this.rows[i].price == "") {
            submit = 1;
            this.rows[i].err_price = "Required";
          } else if (parseFloat(this.rows[i].price) <= 0) {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          } else if (
            price.test(this.rows[i].price) == false &&
            this.rows[i].price != ""
          ) {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          }
          

          //if(this.rows[i].onlinesaleprice==''){
              //submit = 1
              //this.rows[i].err_onlinesaleprice = 'Required';
            //}else if(parseFloat(this.rows[i].onlinesaleprice)<=0){
             // submit = 1
             // this.rows[i].err_onlinesaleprice = 'Invalid Price';
            //}else if(price.test(this.rows[i].onlinesaleprice)==false  && this.rows[i].onlinesaleprice!=''){
              //submit = 1
             // this.rows[i].err_onlinesaleprice = 'Invalid Price';
            //}

          if (this.rows[i].qty == "") {
            submit = 1;
            this.rows[i].err_qty = "Required";
          } else if (parseFloat(this.rows[i].qty) <= 0.0) {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          } else if (
            price.test(this.rows[i].qty) == false &&
            this.rows[i].qty != ""
          ) {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          }

          if (
            igstexp.test(this.rows[i]["igst"]) == false &&
            this.rows[i]["igst"] != ""
          ) {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["igst"]) < 0) {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          }

          if (
            tax.test(this.rows[i]["cgst"]) == false &&
            this.rows[i]["cgst"] != 0
          ) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["cgst"]) < 0) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          }

          if (
            tax.test(this.rows[i]["sgst"]) == false &&
            this.rows[i]["sgst"] != 0
          ) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["sgst"]) < 0) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          }
        }
      }

      if (
        this.selectedcustomer == null ||
        this.selectedcustomer.supplier_id == null ||
        this.selectshop == null ||
        this.selectshop.est_shop_id == null
      ) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (
          this.selectedcustomer == null ||
          this.selectedcustomer.supplier_id == null
        ) {
          this.haserror.cust = "Please Select Supplier";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }
        if (this.rows.length == 0) {
          alert("Nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay == "") {
            submit = 1;
            alert("Nothing To Save");
          } else if (parseFloat(this.detail.totalamtpay) < 0) {
            submit = 1;
            alert("Invalid Entry");
          } else {
            if (submit == 0) {
              this.amt_rec = "";
              this.chequeno_validate = "";
              this.chequedate_validate = "";

              /*  if(this.selected_pytype === 'full'){
                if(parseInt(this.chng) < 0){
                  alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)')
                  this.totalamtreceived = ''
                  this.chng = 0
                  return
                }
                this.detail.totalamtpendingpay = 0
              }
              else if(this.selected_pytype === 'partial'){
                if(parseInt(this.bal) < 0){
                  alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)')
                  this.totalparamtreceived = ''
                  this.bal = 0
                  return
                }
                this.detail.totalamtpendingpay = this.bal
              }*/

              var amount_pay = 0.0;
              if (this.selected_pytype === "full") {
                var chk_full = false;
                if (parseFloat(this.chng) < 0.0) {
                  this.amt_rec =
                    "Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)";
                  this.totalamtreceived = "";
                  this.chng = 0;
                  chk_full = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                  this.chequeno_validate = "Required";
                  chk_full = true;
                }
                if (
                  this.selected_pymode == "cheque" &&
                  this.cheque_date == ""
                ) {
                  this.chequedate_validate = "Required";
                  chk_full = true;
                }
                if (chk_full == true) {
                  return;
                } else {
                  amount_pay = this.total_amt_to_pay;
                  this.detail.totalamtpendingpay = 0;
                }
              } else if (this.selected_pytype === "partial") {
                var chk_partail = false;
                if (
                  parseInt(this.totalparamtreceived) == 0 ||
                  this.totalparamtreceived == ""
                ) {
                  this.totalparamtreceived = "";
                  this.amt_rec = "Required";
                  this.bal = 0;
                  chk_partail = true;
                }
                if (parseInt(this.bal) < 0) {
                  this.totalparamtreceived = "";
                  this.amt_rec =
                    "Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)";
                  this.bal = 0;
                  chk_partail = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                  this.chequeno_validate = "Required";
                  chk_partail = true;
                }
                if (
                  this.selected_pymode == "cheque" &&
                  this.cheque_date == ""
                ) {
                  this.chequedate_validate = "Required";
                  chk_partail = true;
                }

                if (chk_partail == true) {
                  return;
                } else {
                  this.detail.totalamtpendingpay = this.bal;
                  amount_pay = this.totalparamtreceived;
                }
              } else {
                this.detail.totalamtpendingpay =
                  this.detail.totalamtpay - this.totalamtpreviouspaid;
                amount_pay = 0;
              }

              if (this.cheque_date != "") {
                var daynum = /^[0-9]{1}$/;
                let date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = "0" + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = "0" + day;
                } else {
                  var day = day;
                }
                var dateval = year + "-" + month + "-" + day;
              } else {
                var dateval = null;
              }

              this.loading = true;
              var data = {};
              data.purchase_id = this.purchase_id;
              data.suppliersid = this.selectedcustomer.supplier_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.remove_pur_items = this.remove_rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.is_cs_gst === true ? this.detail.cgst : "0";
              data.sgst = this.is_cs_gst === true ? this.detail.sgst : "0";
              data.igst = this.is_cs_gst === false ? this.detail.igst : "0";
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = {
                paytype: "",
                paymode: "",
                chqno: "",
                chqdt: "",
                amt: 0,
              };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;
              // data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay)
              data.pay.amt = amount_pay;
              if (this.productType === 'silver') {
  data.product_type = 'silver';
} else {
  // Do NOT include product_type in the data object
  delete data.product_type; // optional: ensures it's removed if previously set
}
               console.log(data)

              _this.$http
                .post("/api/purchases/editdata", data).then(function (response) {
                  
                   // console.log(response.data.res.status_Code)
                  if(response.data.res.status_Code== 200){
                _this.loading = false;
                  setTimeout(function () {
                    _this.chng = "";
                    _this.bal = "";
                    _this.cheque_no = "";
                    _this.cheque_date = "";
                    _this.loadPurchaseData();
                    _this.loading = false;
                  }, 1000);
                  document.body.scrollTop = 0;
                  document.documentElement.scrollTop = 0;
                  _this.haserror.message = "Purchase Updated Successfully";
                  setTimeout(function () {
                    _this.haserror.message = "";
                  }, 2000);
                  } else if(response.data.res.status_Code== 401){
                  _this.loading=false;
                  _this.haserror.message= 'Something went Wrong';
                  setTimeout(function(){ _this.haserror.message='';}, 3000);
                  }
                 
                })
                .catch(function (error) {
                  _this.loading = false;
                  console.log(error);
                });
            }
          }
        }
      }
    },

    reset() {
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = "";
      this.detail.addition = "";
      this.detail.tot = "";
      this.detail.cgst = "";
      this.detail.sgst = "";
      this.detail.igst = "";
      this.detail.taxamt = "";
      this.detail.totalamtpay = "";
      this.detail.totalamtpendingpay = "";
      this.chng = "";
      this.selectcarat=null,
      this.making_charges="",
      this.weight="",
      this.netweight="",
      this.wastage="",
      this.bal = "";
      this.cheque_no = "";
      this.cheque_date = "";
      this.selected_pymode = "cash";
      this.selected_pytype = "full";
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }

      for (var i = 0; i < 2; i++) {
        this.rows.push({
          productnamex: [],
          selectedproductid: "",
          unit: "",
          unitvalue: "",
          selectproductrow: null,
          price: "",
          qty: "",
          amt: "",
          cgst: 0,
          sgst: 0,
          igst: "",
          amttotal: 0,
          batchmd1: "",
          serialmd1: "",
          percentagemd1: "",
          amtmd1: "",
          variantrow: "n/a",
          inclusive1: false,
          salepricemd1: 0,
          is_adjustment: false,
          adjustment_list: [],
          adjusted: [],
          err_qty: "",
          err_price: "",
          err_sub_total: "",
          err_onlinesaleprice:"",
          err_sgst: "",
          err_cgst: "",
          err_igst: "",
          showvariant: false,
          novariant: false,
          productExist: "",
          item_seqno: "",
        });
      }
    },
  },
};
</script>

<style type="text/css">
.position-relative {
  position: relative;
}

.expandable-input {
  transition: all 0.3s ease;
}
.bell {
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  1% {
    -webkit-transform: rotateZ(30deg);
  }
  3% {
    -webkit-transform: rotateZ(-28deg);
  }
  5% {
    -webkit-transform: rotateZ(34deg);
  }
  7% {
    -webkit-transform: rotateZ(-32deg);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  11% {
    -webkit-transform: rotateZ(-28deg);
  }
  13% {
    -webkit-transform: rotateZ(26deg);
  }
  15% {
    -webkit-transform: rotateZ(-24deg);
  }
  17% {
    -webkit-transform: rotateZ(22deg);
  }
  19% {
    -webkit-transform: rotateZ(-20deg);
  }
  21% {
    -webkit-transform: rotateZ(18deg);
  }
  23% {
    -webkit-transform: rotateZ(-16deg);
  }
  25% {
    -webkit-transform: rotateZ(14deg);
  }
  27% {
    -webkit-transform: rotateZ(-12deg);
  }
  29% {
    -webkit-transform: rotateZ(10deg);
  }
  31% {
    -webkit-transform: rotateZ(-8deg);
  }
  33% {
    -webkit-transform: rotateZ(6deg);
  }
  35% {
    -webkit-transform: rotateZ(-4deg);
  }
  37% {
    -webkit-transform: rotateZ(2deg);
  }
  39% {
    -webkit-transform: rotateZ(-1deg);
  }
  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }
  1% {
    -moz-transform: rotate(30deg);
  }
  3% {
    -moz-transform: rotate(-28deg);
  }
  5% {
    -moz-transform: rotate(34deg);
  }
  7% {
    -moz-transform: rotate(-32deg);
  }
  9% {
    -moz-transform: rotate(30deg);
  }
  11% {
    -moz-transform: rotate(-28deg);
  }
  13% {
    -moz-transform: rotate(26deg);
  }
  15% {
    -moz-transform: rotate(-24deg);
  }
  17% {
    -moz-transform: rotate(22deg);
  }
  19% {
    -moz-transform: rotate(-20deg);
  }
  21% {
    -moz-transform: rotate(18deg);
  }
  23% {
    -moz-transform: rotate(-16deg);
  }
  25% {
    -moz-transform: rotate(14deg);
  }
  27% {
    -moz-transform: rotate(-12deg);
  }
  29% {
    -moz-transform: rotate(10deg);
  }
  31% {
    -moz-transform: rotate(-8deg);
  }
  33% {
    -moz-transform: rotate(6deg);
  }
  35% {
    -moz-transform: rotate(-4deg);
  }
  37% {
    -moz-transform: rotate(2deg);
  }
  39% {
    -moz-transform: rotate(-1deg);
  }
  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }
  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }
  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/purches/editpurchase.vue